import Marquee from "react-fast-marquee";
import { useLanguage } from "../i18n";

export const MarqueeRibbon = ({ outline = false }) => {
  const { t } = useLanguage();
  return (
    <div className="py-10 border-y border-white/5 overflow-hidden" data-testid={outline ? "marquee-outline" : "marquee-filled"} aria-hidden="true">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {t.marquee.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-bold text-4xl md:text-6xl tracking-tight mx-6 ${outline ? "text-stroke" : "text-white/10"}`}>
              {word}
            </span>
            <span className="text-brand-cyan/60 text-2xl mx-2">//</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
